export function formatDateLocal(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function periodToDateRange(year: number, month: number | null): { start_date: string; end_date: string } {
  if (month == null) {
    return {
      start_date: `${year}-01-01`,
      end_date: `${year}-12-31`,
    };
  }
  const lastDay = new Date(year, month, 0).getDate();
  const mm = String(month).padStart(2, "0");
  return {
    start_date: `${year}-${mm}-01`,
    end_date: `${year}-${mm}-${String(lastDay).padStart(2, "0")}`,
  };
}
